module.exports = __webpack_public_path__ + "static/media/imagem3.e9eef7a9.jpeg";